import store from '@/store'
import { aclHelper } from '@/utils/aclHelper'

export const canAccessRouteByUserType = (route) => {
  const meta = route.meta || {}
  return !(meta.userTypeAcl && !meta.userTypeAcl())
}

export const canAccessRouteByPermission = (route) => {
  const isContractor = store.getters['user/isContractor']
  const matched = route.matched || []
  for (let i = 0; i < matched.length; i++) {
    let routeRecord = matched[i]
    if (matched.length > 1 && routeRecord.parent === undefined && !routeRecord.meta.acl) {
      continue
    }
    if (store.state.user.currentUser && routeRecord.meta.acl) {
      const permTypes = routeRecord.meta.acl.permTypes
      const fallback = routeRecord.meta.acl.fallback
      const contractorView = routeRecord.meta.acl.contractorView
      const validUserToAccess = (isContractor && contractorView) || !(isContractor || contractorView)
      if (permTypes && permTypes.length > 0) {
        const allowed = permTypes.some((permType) => {
          const granted = aclHelper.getAccess(permType)
          return granted
        })

        return Boolean(allowed || (validUserToAccess && fallback))
      }
    }
    return true
  }
  return true
}

export const canAccessRoute = (route) => {
  return canAccessRouteByUserType(route) && canAccessRouteByPermission(route)
}
